module.exports = __webpack_public_path__ + "static/media/icons8-doughnut-chart.94846bed.svg";